/**
 * index: Application entry point.
 * - Creates the root React DOM node and renders <App />
 * - Wraps rendering in StrictMode for highlighting potential issues
 * - Kicks off performance reporting via `reportWebVitals`
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // StrictMode activates additional checks/warnings in development
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
